import { useEffect } from 'react';

export interface SeoHeadProps {
  jsonLd: Record<string, unknown>;
}

export default function SeoHead({ jsonLd }: SeoHeadProps) {
  useEffect(() => {
    const scriptId = 'readdy-seo-jsonld';
    const existing = document.getElementById(scriptId);
    if (existing) {
      existing.remove();
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) {
        el.remove();
      }
    };
  }, [jsonLd]);

  return null;
}